import React from 'react';
import {
    Button,
    FormControl,
    Grid,
    MenuItem,
    Paper,
  } from "@material-ui/core";
import { CboCentrosMedicos } from '../../cbos/CboCentrosMedicos';
import { CboProfesionales } from '../../cbos/CboProfesionales';
import { CboEspecialidades } from '../../cbos/CboEspecialidades';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { SelectValidator } from 'react-material-ui-form-validator';
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";

export const ParametrosBaja = (props) => {
    const { 
        handleInputChangeCascada, classes, idCentroMedico, idProfesional, setIdEspecialidad, 
        idEspecialidad, handleInputChange, idParametrizacion, itemsParametrizaciones, 
        translateDia, formatFecha, fechaDesde, fechaHasta, setearValor, 
        setearVariosValores 
    } = props;
    
    return ( 
        <>
            <Grid container direction="row" alignItems="center">
                <Grid item xs={12} md={4}>
                    <Paper className={classes.input}>
                        <CboCentrosMedicos 
                            manejadorInputChange={handleInputChangeCascada}
                            idCombo={'idCentroMedico'}
                            filtrarPorUsuario={true}
                            valor={idCentroMedico}
                        />
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Paper className={classes.input}>
                        <CboProfesionales 
                            manejadorInputChange={handleInputChangeCascada}
                            idCentroMedico={idCentroMedico}
                            cargarEnCascada={true}
                            porCentroMedico={true}
                            valor={idProfesional}
                            required={'required'}
                        />
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Paper className={classes.input}>
                        <CboEspecialidades
                            manejadorInputChange={handleInputChangeCascada}
                            setIdEspecialidad={setIdEspecialidad}
                            idCentroMedico={idCentroMedico}
                            idProfesional={idProfesional}
                            cargarEnCascada={true}
                            valor={idEspecialidad}
                            cargarHorarios={true}
                        />
                    </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Paper className={classes.input}>
                        <FormControl
                            margin="normal"
                            fullWidth={true}
                        >
                            <SelectValidator
                                onChange={handleInputChange}
                                label="Parametrizaciones"
                                name="idParametrizacion"
                                value={idParametrizacion}
                                fullWidth={true}
                                /* validators={['required']}
                                errorMessages={['Seleccione una opción']} */
                            >
                                <MenuItem value={null}>
                                <em>Seleccione</em>
                                </MenuItem>
                                {itemsParametrizaciones.map((item) => (
                                <MenuItem key={item.idEfHorario} value={item.idEfHorario}>
                                    <div>{`Día: ${translateDia(item.dia)} - Hora Desde: ${item.horaDesde}:${item.minDesde} - Hora Hasta: ${item.horaHasta}:${item.minHasta}`}</div>
                                    <div>{`Duración: ${item.duracion} min  - Modalidad: ${item.idTipoTurno === 1 ? 'Presencial' : (item.idTipoTurno === 2 ? 'Virtual' : 'Presencial o Virtual')}`}</div>
                                    <div>{`Fecha Desde: ${formatFecha(item.fechaInicio)} - Fecha Hasta: ${formatFecha(item.fechaFin)}`}</div>
                                </MenuItem>
                                ))}
                            </SelectValidator>
                        </FormControl>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={2}>
                    <Paper className={classes.input}>
                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                margin="normal"
                                label="Fecha Desde"
                                format="dd/MM/yyyy"
                                required={true}
                                clearLabel="Limpiar"
                                cancelLabel="Cancelar"
                                value={
                                    moment(fechaDesde).isValid()
                                    ? moment(fechaDesde)
                                    : 0
                                }
                                onChange={(date) => {                                    
                                    if(moment(date).isAfter(moment(fechaHasta), 'day') )
                                        setearVariosValores({
                                            fechaDesde:  date,
                                            fechaHasta: date  
                                        })
                                    else
                                        setearValor("fechaDesde", date);
                                }}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Paper>  
                </Grid>
                <Grid item xs={12} md={2}>
                    <Paper className={classes.input}>
                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                margin="normal"
                                label="Fecha Hasta"
                                format="dd/MM/yyyy"
                                required={true}
                                clearLabel="Limpiar"
                                cancelLabel="Cancelar"
                                value={
                                    moment(fechaHasta).isValid()
                                    ? moment(fechaHasta)
                                    : 0
                                }
                                onChange={(date) => {
                                    if(moment(date).isBefore(moment(fechaDesde), 'day') )
                                        setearVariosValores({
                                            fechaDesde:  date,
                                            fechaHasta: date  
                                        })
                                    else
                                        setearValor("fechaHasta", date);
                                }}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Paper>  
                </Grid>
                <Grid item xs={12} md={2}>
                    <Paper style={{padding: 28}}>
                        <Button
                            variant="contained"
                            color="primary"
                            type='submit'
                        >
                            Consultar
                        </Button>
                    </Paper>
                </Grid>
            </Grid>
        </>
     );
}